import {filter, map, scan, skipUntil, withLatestFrom} from 'rxjs/operators';
import {strArrDiff} from '@/helper/utils';
import {wsLogin$} from '@/user/auth-ws';
import {toWsMsg$, wsMsg$} from '@/ws';
import {contractSubUserIds$, mainUserId$} from '@/raw/users';
import type {RasMsg} from '@/types/ws';

// 过滤出未订阅的账户，防止重复订阅
// 新增子账号暂时会订阅失败，原因是：做auth验证时，后端会缓存最新用户数据，此时并没有新增的子账号，auth会认证失败
const subUserIds$ = contractSubUserIds$.pipe(skipUntil(wsLogin$), scan(strArrDiff(), {origin: '', add: []}));

subUserIds$
  .pipe(
    skipUntil(wsLogin$),
    filter((userIds) => userIds.add.length > 0)
  )
  .subscribe((userIds) => sub(userIds.add));

wsLogin$
  .pipe(
    withLatestFrom(subUserIds$),
    filter(([, userIds]) => userIds.origin.length > 0)
  )
  .subscribe(([, userIds]) => {
    const userIds2 = userIds.origin.split(',').map((o) => Number(o));
    sub(userIds2);
  });

function sub(userIds: number[]) {
  if (userIds.length > 0) {
    toWsMsg$.next({method: 'ras.subscribe', params: [userIds]});
  }
}

export const rasMsgSubUsers$ = wsMsg$.pipe(
  filter((o: RasMsg) => !!o.risk_units),
  withLatestFrom(mainUserId$),
  filter(([o, userId]) => o.risk_units.filter((items) => items.userID !== userId).length > 0),
  map(([o]) => {
    return {
      userId: o?.risk_units[0]?.userID,
      data: {
        ...o,
      },
    };
  })
);
